<div class="agb" [class.agb-dialog]="mode === 'dialog'">
    <div class="header">
        <h2 class="main-header">Allgemeine Geschäftsbedingungen für die Nutzung von BIMSWARM</h2>
        <div class="normal-text">
            <span>
                Die Allgemeinen Geschäftsbedingungen über die Nutzung der Online-Plattform BIMSWARM sind nachfolgend
                geregelt. Diese sind aufgeteilt in Teil A und Teil B, wobei <b>Teil A</b> die Nutzung der
                Online-Plattform regelt und <b>Teil B</b> besondere zusätzliche Regelungen für die Nutzung der
                Online-Plattform durch das Listen von Bau-IT-Produkten als <b>Anbieter</b> regelt.
            </span>
        </div>
    </div>
    <div class="teil-A">
        <h2 class="section-header">
            Teil A<br>
            Allgemeine Geschäftsbedingungen für die Nutzung von<br>BIMSWARM
        </h2>
        <div class="normal-text intro">
            <span>
                Die nachfolgenden Allgemeinen Geschäftsbedingungen unter diesem Teil A regeln die Nutzung der
                Online-Plattform BIMSWARM.
            </span>
            <div class="content">
                <ol>
                    <li><span class="sub-header">Gegenstand und Anwendungsbereich</span>
                        <ol>
                            <li>
                                BIMSWARM GmbH („<b>BIMSWARM</b>“) betreibt auf der Website
                                <a href="https://bimswarm.online" target="_blank" rel="noopener noreferrer" >www.bimswarm.online</a> eine Online-Plattform („<b>Plattform</b>“). BIMSWARM   
                                bietet Anbietern und Zertifizierern von BIM und Bau-IT-Produkten die   
                                Plattform zur Präsentation und zum Angebot ihrer BIM und Bau-IT-
                                Produkte und zum Zwecke der Zusammenführung von Anbietern und
                                Anwendern von BIM und Bau-IT-Produkten. Das Produktangebot auf der
                                Plattform umfasst Bau-Software einschließlich KI und IT-Hardware-
                                Produkte und -Lösungen wie z.B. Kommunikations- und
                                Recheninfrastruktur sowie Bau-Robotik („<b>Bau-IT-Produkte</b>“).
                            </li>
                            <li>
                                Diese Allgemeinen Geschäftsbedingungen („<b>Plattformbedingungen</b>“) regeln die
                                allgemeine Nutzung der Plattform.

                            </li>
                            <li>
                                Die Nutzung der Plattform erfolgt durch registrierte oder nicht registrierte Nutzer,
                                wobei bestimmte Funktionen und Dienste der Plattform nur registrierten Nutzern
                                vorbehalten sind. Registrierte Nutzer können zudem eigene Bau-IT-Produkte auf der
                                Plattform anbieten. Die nachfolgenden Bestimmungen gelten für alle Nutzer
                                gleichermaßen. Sofern sich einzelne Regelungen nur auf registrierte Nutzer beziehen,
                                sind diese als solche benannt. Als Nutzer im Sinne dieser Plattformbedingungen gelten
                                ausschließlich Unternehmen im Sinne von § 14 BGB, juristische Personen des
                                öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen.
                            </li>
                            <li>
                                BIMSWARM wird nicht Vertragspartei von Verträgen, die ausschließlich zwischen
                                Anbietern und Nutzern geschlossen werden.
                            </li>
                            <li>
                                Allgemeine Geschäftsbedingungen, auf die der Nutzer vor/bei Abschluss des
                                Nutzungsvertrages gemäß Teil A Ziff. 3 hingewiesen hat, finden keine Anwendung,
                                wenn und soweit sie mit diesen Plattformbedingungen in Widerspruch stehen. In
                                jedem Fall gelten die Bedingungen des Nutzers nur, wenn BIMSWARM ihnen
                                ausdrücklich zugestimmt hat.
                            </li>
                            <li>
                                BIMSWARM kann diese Plattformbedingungen jederzeit aktualisieren und wird den
                                Nutzer durch Aktualisierung des letzten Aktualisierungsdatums über solche
                                Änderungen informieren. Durch die weitere Inanspruchnahme der Plattform nach
                                Inkrafttreten der Änderungen erklärt sich der Nutzer mit den neuen Bedingungen
                                einverstanden. Wenn der Nutzer mit den neuen Bedingungen nicht einverstanden ist,
                                muss er die Nutzung der Plattform einstellen.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Leistungsbeschreibung und Verfügbarkeit der Plattform</span>
                        <ol>
                            <li>
                                Die Leistung von BIMSWARM beschränkt sich auf das Zurverfügungstellen einer
                                Plattform, die es ermöglicht, sich einen Überblick über verschiedene Angebote von
                                Bau-IT-Produkten mithilfe einer strukturierten Darstellung von ausführlichen
                                Angebotsinformationen zu verschaffen sowie über die Plattform Bau-IT-Produkte zu
                                erwerben.
                            </li>
                            <li>
                                BIMSWARM stellt die technische und organisatorische Infrastruktur zur Verfügung,
                                über die Bau-IT-Produkte präsentiert und angeboten werden können.
                            </li>
                            <li>
                                Nutzer der Plattform können unter den gelisteten Bau-IT-Produkten auf der Plattform
                                durch das Setzen von Filtern oder mit Hilfe einer Suchfunktion auf ihren Bedarf
                                passende Bau-IT-Produkte finden. Nutzer können sich zudem über die auf der
                                Plattform enthaltenen Zertifizierungsstellen informieren und bereits erteilte
                                Zertifikate überblicken. Zusätzlich wird die Anwendung unterstützt durch die BIMSWARM-Zertifizierung,
                                ein Zertifikat für bestimmte Produkttypen, die durch BIMSWARM-Fachgruppen erstellt
                                werden. Registrierten Nutzern stehen erweiterte Funktionen zur
                                Verfügung wie das Hinterlassen von Kommentaren und Nutzerbewertungen sowie das
                                Anlegen von Favoriten-Listen.
                            </li>
                            <li>
                                Die Details der Angebote von Bau-IT-Produkten der jeweiligen Anbieter werden den
                                Nutzern über eine Produktdetailseite des jeweiligen Bau-IT-Produktes angezeigt. Die
                                auf der Produktdetailseite präsentierten Inhalte bzw. Details (z.B. Beschreibungen,
                                Merkmale, Verfügbarkeiten, Bilder) werden durch den Anbieter selbst bereitgestellt
                                und gestaltet.
                            </li>
                            <li>
                                BIMSWARM behält sich das Recht vor, Änderungen an der Plattform vorzunehmen,
                                soweit dies unter Berücksichtigung der berechtigten Interessen von BIMSWARM für
                                die Anbieter zumutbar ist und die Änderung der Anpassung der Plattform an
                                technische Entwicklungen, Änderungen der Nutzerzahlen, Änderungen des
                                Nutzerverhaltens oder Änderungen der Nutzererwartungen dient.
                            </li>
                            <li>
                                BIMSWARM gewährleistet für die Nutzung der Plattform eine monatliche
                                durchschnittliche Verfügbarkeit von 95%. Bei der Berechnung der Verfügbarkeit sind
                                regelmäßige Ausfallzeiten für Wartungsarbeiten nicht berücksichtigt, die BIMSWARM
                                nach Möglichkeit vorrangig an Wochenenden durchführen wird. Im Übrigen besteht
                                ein Anspruch auf Nutzung der Plattform nur im Rahmen der technischen und
                                betrieblichen Möglichkeiten von BIMSWARM. BIMSWARM ist bestrebt, die Nutzung
                                der Plattform möglichst störungsfrei zu gestalten. Dennoch kann es aufgrund von
                                technischen Störungen (z.B. Unterbrechung der Stromversorgung, Hard- und
                                Softwarefehler, technische Probleme in den Datenleitungen) zu vorübergehenden
                                Einschränkungen oder Unterbrechungen kommen. Für diese übernimmt BIMSWARM
                                keine Haftung. Gleiches gilt für alle technischen oder sonstigen Schwierigkeiten, die
                                BIMSWARM nicht zu vertreten hat und die die Möglichkeit der Nutzung unterbrechen,
                                einschränken oder anderweitig verhindern.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Registrierung; Nutzerkonto</span>
                        <ol>
                            <li>
                                Für eine Registrierung auf der Plattform ist die Erstellung eines Nutzerkontos
                                erforderlich sowie die Zustimmung zu diesen Plattformbedingungen im Rahmen der
                                Registrierung. Ein Anspruch auf Abschluss eines Nutzungsvertrages mit BIMSWARM
                                besteht nicht.
                            </li>
                            <li>
                                Die Registrierung darf nur durch eine vertretungsberechtigte natürliche Person
                                erfolgen, die namentlich genannt werden muss. Natürliche Personen müssen
                                unbeschränkt geschäftsfähig sein und das 18. Lebensjahr vollendet haben.
                            </li>
                            <li>
                                Dabei verpflichtet sich der Nutzer zur richtigen und vollständigen Angabe der
                                abgefragten Daten, insbesondere auch einer gültigen E-Mail-Adresse. Ändern sich die
                                Daten des Nutzers nach der Registrierung, ist der Nutzer verpflichtet, die Angaben in
                                seinem Nutzerkonto unverzüglich zu aktualisieren.
                            </li>
                            <li>
                                Erhält BIMSWARM einen Hinweis oder hat BIMSWARM anderweitig Grund zu der
                                Annahme, dass die vom registrierten Nutzer bereitgestellten Informationen ganz oder
                                teilweise unrichtig, unvollständig oder nicht aktuell sind, ist BIMSWARM berechtigt,
                                den registrierten Nutzer aufzufordern, unverzüglich Abhilfe zu schaffen. Korrigiert
                                oder vervollständigt der registrierte Nutzer die Informationen nicht innerhalb der
                                gesetzten Frist, ist BIMSWARM berechtigt, den Zugang des Nutzers zur Plattform zu
                                sperren, bis der registrierte Nutzer der Aufforderung vollständig nachgekommen ist.
                            </li>
                            <li>
                                Der registrierte Nutzer hat sein Passwort geheim zu halten und den Zugang zu seinem
                                Account sorgfältig zu sichern. Der Nutzer ist verpflichtet, BIMSWARM unverzüglich zu
                                informieren, wenn Anhaltspunkte dafür vorliegen, dass ein Account von einem Dritten
                                missbraucht wurde.
                            </li>
                            <li>
                                Das Nutzerkonto darf nicht an einen Dritten abgetreten werden
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Vertragsparteien</span>
                        <ol>
                            <li>
                                Vertragsparteien des Nutzungsvertrags sind BIMSWARM und der Nutzer.
                            </li>
                            <li>
                                BIMSWARM ist im Falle von Angeboten für Bau-IT-Produkte durch die Anbieter von
                                gelisteten Bau-IT-Produkten nicht der Vertragspartner und übernimmt daher weder
                                eine Garantie für die Erfüllung noch eine Haftung für Ansprüche im Zusammenhang
                                mit Vertragsschlüssen über Bau-IT-Produkte zwischen einem Nutzer und einem
                                Anbieter. Der Anbieter ist allein verantwortlich für den Vertragsschluss über
                                Bau-IT-Produkte, jegliche Reklamation von Seiten des Nutzers und alle anderen
                                Angelegenheiten, die durch den Vertrag zwischen Nutzer und Anbieter entstehen (inkl.
                                Lieferung, Gewährleistung, Rückabwicklung, Abführung von Steuern etc.).
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Nutzungsrechte</span>
                        <div class="sub-content">
                            <span>
                                Mit dem Abschluss des Nutzungsvertrags erhält der Nutzer das Recht, die Plattform
                                nach Maßgabe der Plattformbedingungen zu nutzen. Soweit ein registrierter Nutzer im
                                Rahmen dieser Nutzung Inhalte (zum Beispiel Kommentare und Nutzerbewertungen)
                                bereitstellt, gewährt er BIMSWARM das nicht-ausschließliche, unentgeltliche,
                                unwiderrufliche, übertragbare und unbefristete Recht (einschließlich des Rechts zur
                                Erteilung von Unterlizenzen), diese auf der Plattform eingestellten Inhalte für die
                                Zwecke der Plattform zu verbreiten, vervielfältigen oder in sonstiger Weise zu
                                bearbeiten und zu nutzen. Insbesondere darf BIMSWARM Inhalte des registrierten
                                Nutzers übersetzen oder auf mobilen Endgeräten darstellbar machen und im Rahmen
                                von Werbung für die Plattform den registrierten Nutzer nennen. Ideen, Anregungen
                                und sonstiges Feedback des Nutzers zur Plattform darf BIMSWARM für eigene
                                Zwecke, insbesondere zur Entwicklung und Verbesserung der Plattform, nutzen.
                            </span>
                        </div>
                    </li>
                    <li><span class="sub-header">Pflichten des Nutzers</span>
                        <ol>
                            <li>
                                Der registrierte Nutzer wird sein Konto nur im Rahmen der hier genannten Grenze
                                nutzen. Er wird es insbesondere unterlassen
                                <ul class="sublist-dash">
                                    <li><span>diffamierende, anstößige oder in sonstiger Weise rechtswidrige Inhalte
                                            zugänglich zu machen;</span></li>
                                    <li><span>andere Personen zu bedrohen, zu belästigen, anzuschwärzen oder die Rechte
                                            (einschließlich Persönlichkeitsrechte) Dritter zu verletzen;</span></li>
                                    <li><span>Daten hochzuladen, die Viren enthalten;</span></li>
                                    <li><span>E-Mails abzufangen oder dies zu versuchen;</span></li>
                                    <li><span>Kettenbriefe zu versenden oder Direktmarketing zu betreiben;</span></li>
                                    <li><span>Logins und persönliche Passwörter an Dritte weiterzugeben oder mit Dritten
                                            gemeinsam zu nutzen;</span></li>
                                    <li><span>die über das Nutzerkonto generierten Daten an Dritte weiterzugeben;</span>
                                    </li>
                                    <li><span>das Nutzerkonto für betrugszwecke oder sonst missbräuchlich zu nutzen oder
                                            Dritten die missbräuchliche Verwendung des Nutzerkontos zu
                                            ermöglichen.</span></li>
                                </ul>
                            </li>
                            <li>
                                Der registrierte Nutzer ist für die Speicherung und Sicherung seiner Inhalte
                                verantwortlich. Die Verarbeitung über die Plattform entbindet den Nutzer nicht von
                                der Einhaltung gesetzlicher oder eigener betrieblicher Aufbewahrungspflichten.
                                BIMSWARM übernimmt keine Aufbewahrungspflichten und haftet nicht für den
                                Verlust von Daten und Informationen.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Nutzerbewertungen</span>
                        <ol>
                            <li>
                                Der registrierte Nutzer hat die Möglichkeit, seine Erfahrungen zu einzelnen Angeboten
                                mit der gesamten BIMSWARM-Community im Rahmen eines Systems für
                                Nutzerbewertungen zu teilen. Die Bewertung, insbesondere die Bewertung durch
                                individuelle Kommentare, muss wahrheitsgemäß und sachlich sein und darf
                                insbesondere folgendes nicht enthalten:
                                <ul class="sublist-dash">
                                    <li><span>Herabsetzungen, zu denen der Verkäufer keinen Anlass gegeben hat,</span>
                                    </li>
                                    <li><span>Boykottaufrufe,</span></li>
                                    <li><span>Werbung und andere kommerzielle Inhalte, oder</span></li>
                                    <li><span>Persönliche und personenbezogene Daten Dritter.</span></li>
                                </ul>
                            </li>
                            <li>
                                Dem registrierten Nutzer ist bekannt, dass diese Bewertungen von BIMSWARM auf der
                                Plattform öffentlich zugänglich gemacht werden können. Hiermit ist er ausdrücklich
                                einverstanden. Ziel der Bewertung ist es, anderen Nutzern eine Qualitätskontrolle zu
                                ermöglichen und so das Qualitätsniveau und damit das Vertrauen in die Plattform zu
                                erhöhen.
                            </li>
                            <li>
                                BIMSWARM ist für den Inhalt der Bewertungen nicht verantwortlich und wird die
                                Bewertungen vor Veröffentlichung weder auf sachliche Richtigkeit noch auf ihre
                                juristische Zulässigkeit prüfen. Wird BIMSWARM über beleidigende, verunglimpfende
                                oder sonst offenkundig rechtswidrige Bewertungen informiert, wird BIMSWARM in
                                diesen Fällen die Inhalte für den Abruf sperren und einen Hinweis veröffentlichen, dass
                                die Bewertung gesperrt werden musste. Im Übrigen behält sich BIMSWARM das Recht
                                vor, Maßnahmen gem. Teil A Ziff. 8.5 zu ergreifen.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Rechtswidrige Inhalte und Maßnahmen zur Moderation von Inhalten</span>
                        <ol>
                            <li>
                                Das Bereitstellen rechtswidriger Inhalte ist auf der Plattform unzulässig. Hierzu zählen
                                auch unzutreffende oder unsachliche Bewertungen von Anbietern durch registrierte
                                Nutzer (Teil A Ziff. 7.1).
                            </li>
                            <li>
                                BIMSWARM ist grundsätzlich nicht verpflichtet, die von Anbietern oder Nutzern
                                eingestellten Inhalte proaktiv auf ihre Rechtmäßigkeit oder Vereinbarkeit mit den
                                Rechten Dritter oder diesen Plattformbedingungen zu prüfen. BIMSWARM ist jedoch
                                berechtigt, von sich aus freiwillige Prüfungen vorzunehmen, um rechtswidrige oder
                                unvereinbare Inhalte zu identifizieren und festzustellen und entsprechende
                                Maßnahmen gemäß Teil A Ziff. 8.5 zu ergreifen.
                            </li>
                            <li>
                                BIMSWARM stellt ein Verfahren zur Verfügung, mit dem vermeintlich rechtswidrige
                                Inhalte auf elektronischem Wege an BIMSWARM gemeldet werden können: Alle
                                Nutzer und auch Dritte haben die Möglichkeit, Angebote und sonstige Inhalte über ein
                                elektronisches Formular an BIMSWARM zu melden. Dieses Formular ist über einen
                                entsprechenden Button auf der jeweiligen Produktseite zugänglich. Weitere
                                Informationen zu dieser Meldefunktion finden Sie <a href="javascript:void(0)"
                                    (click)="openContactDialog();">hier</a>.
                            </li>
                            <li>
                                Im Rahmen der freiwilligen Überprüfungen nach Teil A Ziff. 8.2 und der Meldungen
                                nach Teil A Ziff. 8.3 setzt BIMSWARM verschiedene Verfahren und Instrumente ein,
                                um Inhalte zu identifizieren, zu prüfen und zu moderieren. Je nach Einzelfall wird dies
                                eine automatisierte Überprüfung oder eine Kombination aus menschlicher und
                                automatisierter Überprüfung umfassen.
                            </li>
                            <li>
                                BIMSWARM kann die folgenden Maßnahmen ergreifen, wenn im Hinblick auf die auf
                                der Plattform eingestellten Inhalte gegen gesetzliche Vorschriften, Rechte Dritter oder
                                diese Plattformbedingungen verstoßen wird:
                                <ul class="sublist-dash">
                                    <li><span>Abmahnung des Betroffenen;</span></li>
                                    <li><span>Löschung von Inhalten, die gegen das Gesetz oder die Nutzungsvereinbarung
                                            verstoßen;</span></li>
                                    <li><span>Sperrung des Zugangs zu Angeboten oder anderen Inhalten;</span></li>
                                    <li><span>Ausblenden von Inhalten, auch auf den Suchergebnisseiten;</span></li>
                                    <li><span>Herabstufung der Auffindbarkeit von Inhalten (Degradierung);</span></li>
                                    <li><span>Verzögerung der Veröffentlichung von Inseraten und anderen
                                            Inhalten;</span></li>
                                    <li><span>Einschränkung der Nutzung von BIMSWARM-Diensten, insbesondere von der
                                            Möglichkeit, Angebote einzustellen oder einzusehen;</span></li>
                                    <li><span>Vorübergehende oder dauerhafte Sperrung des Plattformkontos.</span></li>
                                </ul>
                            </li>
                            <li>
                                Bei der Wahl der Maßnahme nach Teil A Ziff. 8.5 berücksichtigt BIMSWARM auch die
                                berechtigten Interessen des von der Maßnahme Betroffenen, anderer Anbieter und
                                Nutzer, etwaiger Rechteinhaber und sonstiger Dritter sowie die eigenen berechtigten
                                Interessen als Betroffener. BIMSWARM berücksichtigt dabei insbesondere die
                                Schwere des jeweiligen Verstoßes und ob Anhaltspunkte dafür vorliegen, dass der
                                Betroffene den Verstoß nicht zu vertreten hat. Darüber hinaus wird BIMSWARM
                                prüfen, ob die jeweilige Maßnahme nur bei Vorliegen eines wichtigen Grundes ergriffen
                                werden kann. Ein wichtiger Grund ist z.B. dann gegeben, wenn die Maßnahme zu
                                schwerwiegenden Nachteilen für den Betroffenen führen kann.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Maßnahmen bei Regelverstößen des Nutzers</span>
                        <div class="sub-content">
                            <span>
                                BIMSWARM kann die unter Teil A Ziff. 8.5 genannten Maßnahmen (unter den dort
                                genannten Voraussetzungen) ergreifen, wenn der Nutzer im Rahmen der Nutzung der
                                Plattform gegen gesetzliche Vorschriften, Rechte Dritter oder diese
                                Plattformbedingungen verstößt. In diesem Fall gilt Teil A Ziff. 8.6 entsprechend.
                            </span>
                        </div>
                    </li>
                    <li><span class="sub-header">Laufzeit; Kündigung</span>
                        <ol>
                            <li>
                                Mit Abschluss der Registrierung/Freischaltung des Nutzerkontos durch BIMSWARM
                                wird dem registrierten Nutzer Zugang zur Plattform auf unbestimmte Zeit gewährt.
                                Der Nutzungsvertrag kann jederzeit durch Mitteilung in Textform gekündigt werden
                                sowie durch Löschung des Nutzerkontos.
                            </li>
                            <li>
                                Das Recht der Parteien, den Nutzungsvertrag außerordentlich zu kündigen, bleibt
                                unberührt.
                            </li>
                            <li>
                                Wird der Nutzungsvertrag gekündigt, so deaktiviert BIMSWARM das Nutzerkonto 10
                                Werktage nach Vertragsende. Gesetzliche Dokumentations- und
                                Aufbewahrungspflichten bleiben unberührt.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Allgemeine Haftung von BIMSWARM</span>
                        <ol>
                            <li>
                                BIMSWARM haftet nur für Vorsatz und grobe Fahrlässigkeit sowie für die Verletzung
                                wesentlicher Vertragspflichten. Eine wesentliche Vertragspflicht liegt vor, wenn sich
                                die Pflichtverletzung auf eine Pflicht bezieht, deren Erfüllung die ordnungsgemäße
                                Durchführung dieses Nutzungsvertrages überhaupt erst ermöglicht oder auf deren
                                Einhaltung der Anbieter regelmäßig vertrauen darf.
                            </li>
                            <li>
                                Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten haftet BIMSWARM
                                nur auf Ersatz des vorhersehbaren, für den Nutzungsvertrag typischen Schadens.
                            </li>
                            <li>
                                Soweit die Haftung von BIMSWARM nach den vorstehenden Regelungen
                                ausgeschlossen oder beschränkt ist, gilt dies nicht für Ansprüche des Anbieters aus der
                                Verletzung des Lebens, des Körpers oder der Gesundheit oder für Ansprüche aus dem
                                Produkthaftungsgesetz.
                            </li>
                            <li>
                                BIMSWARM haftet für seine Erfüllungsgehilfen und gesetzlichen Vertreter nach
                                Maßgabe der vorstehenden Bestimmungen.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Datenschutz und Verantwortlichkeiten</span>
                        <div class="sub-content">
                            <span>
                                Über die Verarbeitung personenbezogener Daten durch BIMSWARM, einschließlich
                                der Weitergabe an Dritte und die Rechte des Anbieters als Betroffener, informiert
                                BIMSWARM in der <a routerLink="/privacy" target="_blank">Datenschutzerklärung</a>.
                            </span>
                        </div>
                    </li>
                    <li><span class="sub-header">Rechtswahl und Gerichtsstand</span>
                        <ol>
                            <li>
                                Für die Nutzung der Plattform und die Rechtsbeziehungen zwischen BIMSWARM und
                                dem Nutzer gilt ausschließlich deutsches Recht. Die Bestimmungen des
                                Übereinkommens der Vereinten Nationen über Verträge über den internationalen
                                Warenkauf (CISG) finden keine Anwendung.
                            </li>
                            <li>
                                Ausschließlicher (auch internationaler) Gerichtsstand für alle Streitigkeiten aus und im
                                Zusammenhang mit dem Rechtsverhältnis zwischen BIMSWARM und dem Nutzer in
                                Bezug auf die Nutzung der Plattform ist Düsseldorf, Deutschland.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Schlussbestimmungen</span>
                        <ol>
                            <li>
                                Die Kontaktdaten des zentralen Ansprechpartners bei BIMSWARM finden Sie <a
                                    routerLink="/impressum" target="_blank">hier</a>.
                            </li>
                            <li>
                                Die Bestimmungen der Plattformbedingungen stellen die gesamte Vereinbarung
                                zwischen BIMSWARM und dem Nutzer in Bezug auf ihren Gegenstand dar. Diese
                                Vereinbarung kann nicht geändert werden, es sei denn, es liegt eine von beiden Parteien
                                unterzeichnete schriftliche Vereinbarung vor oder es gelten die Bestimmungen in Teil
                                A Ziff. 1.6.
                            </li>
                            <li>
                                Sollte eine Bestimmung der Plattformbedingungen von einem zuständigen Gericht
                                rechtskräftig für rechtswidrig, ungültig oder ganz oder teilweise nicht durchsetzbar
                                erklärt werden, so bleiben die übrigen Bestimmungen der Plattformbedingungen
                                davon unberührt. Die unwirksame Bestimmung gilt als durch eine Bestimmung ersetzt,
                                die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
                                Das Gleiche gilt für eine ungewollte Regelungslücke.
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
    </div>
        <div class="teil-B">
        <h2 class="section-header">
            Teil B<br>
            Zusätzliche besondere Bedingungen für Anbieter von Bau-IT-Produkten
        </h2>
        <div class="normal-text intro">
            <span>
                Die nachfolgenden Bedingungen unter diesem Teil B stellen zusätzliche besondere Bedingungen für die
                Nutzung der Online-Plattform durch das Anbieten von Bau-IT-Produkten auf der Plattform durch Anbieter
                dar („<b>Listung</b>“).
            </span>
            <div class="content">
                <ol>
                    <li><span class="sub-header">Gegenstand und Anwendungsbereich</span>
                        <div class="sub-content">
                            <span>
                                Die unter diesem Teil B der Plattformbedingungen enthaltenen besonderen
                                Bedingungen regeln die Inanspruchnahme der Leistungen von BIMSWARM auf der
                                Plattform durch registrierte Nutzer im Sinne von Teil A dieser Plattformbedingungen,
                                die ihre Bau-IT-Produkte als Anbieter auf der Plattform listen und anbieten
                                („<b>Anbieter</b>“). Für Anbieter gelten im Übrigen die Regelungen gemäß Teil A dieser
                                Plattformbedingungen.
                            </span>
                        </div>
                    </li>
                    <li><span class="sub-header">Listung von Bau-IT-Produkten</span>
                        <ol>
                            <li>
                                Anbieter können ihre Bau-IT-Produkte auf der Plattform anbieten, indem sie diese auf
                                der Plattform listen. Die Listung von Bau-IT-Produkten auf der Plattform erfordert
                                zum einen die Registrierung des Anbieters auf der Plattform als Nutzer, wie unter Teil
                                A Ziff. 3 dieser Plattformbedingungen dargestellt und darüber hinaus die Anlegung
                                einer Organisationsstruktur sowie die Zustimmung zu diesen Plattformbedingungen.
                                Ferner schließt der Anbieter mit BIMSWARM ein Abonnement ab. BIMSWARM bietet
                                hierzu verschiedene kostenpflichtige Abonnement-Modelle an. Das aktuelle Angebot
                                sowie die jeweils unter den verschiedenen Abonnement-Modellen gebotenen
                                Leistungen von BIMSWARM sowie deren Bedingungen können den verschiedenen
                                Abonnement-Modellen entnommen werden. Diese finden Sie <a routerLink="/tarife"
                                    target="_blank">hier</a>.
                                Ein Anspruch auf Abschluss eines Vertrages mit BIMSWARM besteht nicht.
                            </li>
                            <li>
                                Die Erstellung der Organisationsstruktur darf nur durch eine vertretungsberechtigte
                                natürliche Person erfolgen. Die von BIMSWARM bei der Erstellung der
                                Organisationsstruktur abgefragten Daten müssen vollständig und richtig sein.
                            </li>
                            <li>
                                Mit der Zustimmung zu den Plattformbedingungen beabsichtigen BIMSWARM und
                                der Anbieter nicht, eine Partnerschaft, ein Joint Venture oder eine stille Gesellschaft
                                zu
                                begründen. Ferner berechtigt die Annahme dieser Plattformbedingungen den Anbieter
                                und BIMSWARM nicht zur gegenseitigen Vertretung.
                            </li>
                            <li>
                                Dabei verpflichtet sich der Anbieter zur richtigen und vollständigen Angabe der
                                abgefragten Daten, insbesondere auch einer gültigen E-Mail-Adresse. Ändern sich die
                                Daten des Anbieters nach Erstellung der Organisationsstruktur, ist der Anbieter
                                verpflichtet, die Angaben in seinem Nutzerkonto unverzüglich zu aktualisieren.
                            </li>
                            <li>
                                Erhält BIMSWARM einen Hinweis oder hat BIMSWARM anderweitig Grund zu der
                                Annahme, dass die vom Anbieter bereitgestellten Informationen ganz oder teilweise
                                unrichtig, unvollständig oder nicht aktuell sind, ist BIMSWARM berechtigt, den
                                Anbieter aufzufordern, unverzüglich Abhilfe zu schaffen. Korrigiert oder
                                vervollständigt der Anbieter die Informationen nicht innerhalb der gesetzten Frist, ist
                                BIMSWARM berechtigt, den Zugang des Anbieters zur Plattform zu sperren, bis der
                                Anbieter der Aufforderung vollständig nachgekommen ist.
                            </li>
                            <li>
                                Der Anbieter hat sein Passwort geheim zu halten und den Zugang zu seinem Account
                                sorgfältig zu sichern. Der Anbieter ist verpflichtet, BIMSWARM unverzüglich zu
                                informieren, wenn Anhaltspunkte dafür vorliegen, dass ein Account von einem Dritten
                                missbraucht wurde.
                            </li>
                            <li>
                                Der Account des Anbieters auf der Plattform darf nicht an einen Dritten abgetreten
                                werden.
                            </li>
                            <li>
                                BIMSWARM gewährt dem Anbieter keine Exklusivität in Bezug auf den Zugang zur
                                Plattform, sei es personell, materiell, räumlich oder in sonstiger Weise, insbesondere
                                nicht für bestimmte Produkte oder Liefergebiete.
                            </li>
                            <li>
                                BIMSWARM schuldet nicht die Vermittlung von Verträgen, die Gewinnung von
                                Kunden für den Anbieter oder einen sonstigen Erfolg des Anbieters durch die Nutzung
                                der Plattform. Insbesondere hat der Anbieter keinen Anspruch auf einen bestimmten
                                Umsatz, eine bestimmte Anzahl oder Form von Anzeigen oder auf die Bewerbung
                                seiner Produkte.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Pflichten der Anbieter</span>
                        <ol>
                            <li>
                                In Bezug auf die Listung von Bau-IT-Produkten muss der Anbieter:
                                <ul class="sublist-dash">
                                    <li><span>sicherstellen, dass alle auf der Plattform präsentierten Daten und
                                            Bestände stets korrekt und aktuell sind, soweit sie sich auf Bau-IT-Produkte
                                            auf der Plattform beziehen;</span></li>
                                    <li><span>nicht mit unwahren oder irreführenden Tatsachenbehauptungen werben;</span>
                                    </li>
                                    <li><span>den ungestörten und ordnungsgemäßen Betrieb der Plattform und die
                                            Integrität der Daten Dritter nicht zu beeinträchtigen;</span></li>
                                    <li><span>nicht unberechtigt auf Systeme oder Daten von BIMSWARM zugreifen;</span>
                                    </li>
                                    <li><span>die Leistungen von BIMSWARM ausschließlich im Rahmen der getroffenen
                                            vertraglichen Regelungen nutzen;</span></li>
                                    <li><span>sich bei Störungen in der Darstellung oder Nichtverfügbarkeit seiner
                                            Angebote auf der Plattform unverzüglich an BIMSWARM wenden.</span></li>
                                </ul>
                            </li>
                            <li>
                                Für die Richtigkeit des Inhalts der Produktdetailseiten und der rechtlichen
                                Informationen des Anbieters im jeweiligen Angebot des Bau-IT-Produktes übernimmt
                                BIMSWARM keine Haftung. Der Anbieter ist für die veröffentlichten Produktdetails
                                und sonstigen Informationen selbst verantwortlich.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Angebote von Bau-IT-Produkten</span>
                        <ol>
                            <li>
                                Hinsichtlich der Vorgaben für die Darstellung des Angebots auf der Produktseite gilt
                                Folgendes:
                                <ul class="sublist-dash">
                                    <li><span>Die Angebote enthalten eine kurze Beschreibung des angebotenen Produkts
                                            sowie mindestens ein Produktbild oder Logo;</span></li>
                                    <li><span>die Produkte sollten sofort verfügbar oder zumindest kurzfristig verfügbar
                                            sein (innerhalb von 10 Tagen);</span></li>
                                    <li><span>die Angebote enthalten Preise.</span></li>
                                </ul>
                            </li>
                            <li>
                                Die Anbieter können lediglich Produkte gemäß der Definition in Teil A Ziff. 1.1 auf der
                                Plattform anbieten.
                            </li>
                            <li>
                                Die Nutzung von Inhalten Dritter ohne die erforderliche Zustimmung des
                                Rechteinhabers (z.B. Lizenz) ist auf der Plattform nicht gestattet.
                            </li>
                            <li>
                                Darüber hinaus hat der Anbieter beim Einstellen von Inhalten wie Bildern, Videos oder
                                Texten auf der Plattform die folgenden Standards zu beachten:
                                <ul class="sublist-dash">
                                    <li><span>Die Verwendung von Markennamen und Logos Dritter in Produktbildern und
                                            anderen Inhalten ist nicht gestattet.</span></li>
                                    <li><span>Unscharfe, undefinierte oder verzerrte Bilder oder Videos sind nicht
                                            erlaubt.</span></li>
                                    <li><span>Inhalte, die Hass, Gewalt oder Diskriminierung fördern oder verherrlichen,
                                            sind nicht gestattet.</span></li>
                                    <li><span>Videos und Bilder dürfen keine Nacktheit zeigen oder sexuell orientierte
                                            Inhalte enthalten.</span></li>
                                    <li><span>Inhalte, die Nutzer von der Plattform wegführen, wie z.B. Fotos oder Texte
                                            mit Kontaktinformationen, Weblinks, URLs oder andere Aussagen, die Nutzer
                                            dazu auffordern, ihre Aktivitäten außerhalb der Plattform durchzuführen
                                            (z.B. „Für weitere Informationen besuchen Sie XY.com“), sind nicht
                                            erlaubt.</span></li>
                                    <li><span>Die Veröffentlichung von personenbezogenen Daten Dritter ist nicht
                                            gestattet.</span></li>
                                </ul>
                            </li>
                            <li>
                                Der Anbieter hat dafür zu sorgen, dass nicht mehr verfügbare Bau-IT-Produkte von
                                der Plattform gelöscht werden.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Vertragsschluss mit Kunden</span>
                        <ol>
                            <li>
                                Der Nutzer kann Anfragen auf BIMSWARM an den Anbieter richten. BIMSWARM
                                leitet die Anfrage entweder direkt an den Anbieter zur weiteren Bearbeitung weiter oder
                                eine Kontaktaufnahme erfolgt direkt mit dem Anbieter. BIMSWARM selbst nimmt
                                keinen Kontakt zu den Nutzern auf. Insbesondere stellt die Weiterleitung der Anfrage
                                des Nutzers durch BIMSWARM kein Angebot oder eine Annahme zum Vertragsschluss
                                zwischen dem Nutzer und dem Anbieter dar. Für die Abwicklung und Erbringung der
                                Leistungen aus dem abgeschlossenen Vertrag sind allein der Anbieter und der Nutzer
                                verantwortlich.
                            </li>
                            <li>
                                Der Anbieter ist für die Zahlungsabwicklung im Zusammenhang mit dem
                                Vertragsverhältnis zwischen dem Anbieter und dem Nutzer allein verantwortlich.
                            </li>
                            <li>
                                BIMSWARM haftet nicht für Ansprüche, die sich aus dem Vertragsverhältnis zwischen
                                dem Anbieter und dem Nutzer ergeben.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Preise und Zahlungsbedingungen</span>
                        <ol>
                            <li>
                                Für den Abschluss eines Abonnements gilt: Der Anbieter wird für die Listung von
                                Bau-IT-Produkten aufgefordert, das gewünschte Abonnement auszuwählen und seine
                                Zahlungsdaten anzugeben.
                            </li>
                            <li>
                                Hat der Anbieter ein kostenpflichtiges Abonnement auf der Plattform abgeschlossen,
                                ist er verpflichtet, den vereinbarten Beitrag an BIMSWARM zu zahlen. Es gelten die
                                Preise des jeweils durch den Anbieter gewählten Abonnements. Die aktuell verfügbaren
                                Abonnement-Modelle und Informationen über deren Preise sind einsehbar unter
                                <a routerLink="/tarife" target="_blank">Produkt Listen</a>. Alle Preise sind in EUR
                                angegeben.
                            </li>
                            <li>
                                Die Zahlung des vereinbarten Abonnement-Preises ist direkt bei Abschluss des
                                Abonnements für den Abonnement-Zeitraum fällig. Die Zahlung erfolgt durch die
                                angebotene Zahlungsmethode. Bei Zahlung mit Kreditkarte wird die Kreditkarte des
                                Anbieters zum in dieser Ziff. 6.3 genannten Fälligkeitszeitpunkt belastet.
                            </li>
                            <li>
                                Die von dem jeweiligen Abonnement-Modell umfassten Leistungen sowie die
                                Bedingungen zur Laufzeit und Kündigungsmöglichkeit des Abonnements sind im
                                Rahmen des Abschlusses des Abonnements einsehbar.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Kontaktperson und Erreichbarkeit</span>
                        <ol>
                            <li>
                                Der Anbieter stellt eine zentrale Anlaufstelle zur Verfügung und gewährleistet deren
                                Erreichbarkeit während der üblichen Geschäftszeiten (werktags, Montag bis Freitag,
                                zwischen 9:00 und 16:00 Uhr Ortszeit) sowie per E-Mail und Post, sowohl für
                                BIMSWARM als auch für Nutzer.
                            </li>
                            <li>
                                Erhält der Anbieter eine Anfrage von BIMSWARM oder von einem Nutzer, so wird der
                                Anbieter innerhalb von vier (4) Tagen antworten. Für den Fall, dass BIMSWARM ein
                                Problem als kritisch einstuft, verpflichtet sich der Anbieter, innerhalb von
                                vierundzwanzig (24) Stunden nach Eingang der Anfrage zu antworten.
                            </li>
                            <li>
                                BIMSWARM möchte Nutzern eine in jeder Hinsicht professionelle und
                                kundenfreundliche Nutzung der Plattform bieten. Der Anbieter wird sich bemühen,
                                Konflikte und Meinungsverschiedenheiten mit Geschäftskunden einvernehmlich zu
                                lösen und eine kundenorientierte Lösung zu suchen.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Haftung der Anbieter und Freistellung</span>
                        <ol>
                            <li>
                                Der Anbieter haftet nach den gesetzlichen Bestimmungen.
                            </li>
                            <li>
                                Der Anbieter stellt BIMSWARM von Ansprüchen Dritter gegen BIMSWARM frei, die darauf
                                beruhen, dass
                                <ul class="sublist-dash">
                                    <li><span>der Anbieter die ihm als verantwortliche Stelle obliegenden Pflichten nach
                                            den geltenden Datenschutzbestimmungen schuldhaft verletzt hat,</span></li>
                                    <li><span>Angebote/Produktangaben des Anbieters Schutzrechte (z.B. Marken-,
                                            Urheber- oder Persönlichkeitsrechte) Dritter verletzen oder rechtswidrig
                                            nutzen oder falsche oder irreführende Angaben enthalten, oder dass</span>
                                    </li>
                                    <li><span>der Anbieter gegen sonstige in diesen Plattformbedingungen vereinbarte
                                            Pflichten verstößt.</span></li>
                                </ul>
                                Die Freistellungsverpflichtung des Anbieters gilt nur, wenn und soweit der Anbieter für
                                die von dem Dritten geltend gemachten Ansprüche und Forderungen schuldhaft
                                verantwortlich ist. Ein Mitverschulden von BIMSWARM bleibt hiervon unberührt.
                                BIMSWARM wird den Anbieter unverzüglich unterrichten, wenn Dritte gegen ihn
                                Ansprüche geltend machen, die unter diese Ziff. 8 fallen und dem Nutzer Gelegenheit
                                geben, sich gegen den geltend gemachten Anspruch zu verteidigen, soweit dies nach
                                den Umständen des Einzelfalles möglich ist. Der Anbieter ist verpflichtet, BIMSWARM
                                unverzüglich alle verfügbaren Informationen über den betreffenden Sachverhalt in
                                Textform zur Verfügung zu stellen. Der Anbieter hat in den vorgenannten Fällen die
                                Kosten der notwendigen Rechtsverteidigung zu tragen. Weitergehende Ansprüche von
                                BIMSWARM bleiben hiervon unberührt.
                            </li>
                        </ol>
                    </li>
                    <li><span class="sub-header">Schlussbestimmungen</span>
                        <div class="sub-content">
                            <span>Es gelten im Übrigen die Regelungen gemäß Teil A dieser Plattformbedingungen.</span>
                        </div>
                    </li>
                </ol>
            </div>
        </div>
    </div>
    <div>
        <span><b>Stand: November 2025</b></span>
    </div>
</div>